import { ChildseatIcon, WheelchairIcon } from '@moia-dev/pace-icons'
import { Heading, Text } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { VehicleTripsLink } from '../../components'
import type { VehicleMissionCardHeaderFragment } from './vehicleMissionCardHeader.hook'

export const VEHICLE_MISSION_CARD_HEADER_HEIGHT = 60

type VehicleMissionCardHeaderProps = {
  vehicle: VehicleMissionCardHeaderFragment
  withTripsLink?: boolean
}

export const VehicleMissionCardHeader = ({
  vehicle,
}: VehicleMissionCardHeaderProps) => {
  const { t } = useTranslation()

  const totalChildrenInVehicle = vehicle.totalChildrenInVehicle ?? 0
  const totalPassengersInVehicle = vehicle.totalPassengersInVehicle ?? 0
  const totalPassengersToPickUp = vehicle.totalPassengersToPickUp ?? 0
  const totalWheelchairUsersInVehicle =
    vehicle.totalWheelchairUsersInVehicle ?? 0

  return (
    <div
      css={theme => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: theme.space.Space2,
        padding: `${theme.space.Space2} ${theme.space.Space3} ${theme.space.Space2} ${theme.space.Space4}`,
        height: VEHICLE_MISSION_CARD_HEADER_HEIGHT,
        zIndex: 100,
        position: 'relative',
        borderBottom: `1px solid ${theme.semantic.ColorAccessoryReduced}`,
        backgroundColor: theme.semantic.ColorSurfaceDefault,
      })}
    >
      <div
        css={theme => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.space.Space3,
        })}
      >
        <Heading size="md" css={{ marginBottom: '2px' }}>
          {t('adFleetMap_missionCard_header')}
        </Heading>
        <div
          css={theme => ({
            display: 'flex',
            alignItems: 'center',
            fontSize: 16,
            gap: theme.space.Space2,
          })}
        >
          <Text size="md" color="reduced" css={{}}>
            {t('adFleetMap_missionCard_passengerOnBoard_label', {
              totalPassengersInVehicle,
            })}
          </Text>
          {totalWheelchairUsersInVehicle > 0 && (
            <div
              css={theme => ({
                display: 'flex',
                alignItems: 'center',
                gap: theme.space.Space1,
              })}
            >
              <WheelchairIcon
                data-testid={'WheelchairIcon'}
                css={theme => ({
                  width: 16,
                  height: 16,
                  color: `${theme.semantic.ColorContentReduced} !important`,
                })}
              />
              <Text size="md" color="reduced">
                {totalWheelchairUsersInVehicle}
              </Text>
            </div>
          )}
          {totalChildrenInVehicle > 0 && (
            <div
              css={theme => ({
                display: 'flex',
                alignItems: 'center',
                gap: theme.space.Space1,
              })}
            >
              <ChildseatIcon
                data-testid={'ChildseatIcon'}
                css={theme => ({
                  width: 16,
                  height: 16,
                  color: `${theme.semantic.ColorContentReduced} !important`,
                })}
              />
              <Text size="md" color="reduced">
                {totalChildrenInVehicle}
              </Text>
            </div>
          )}
        </div>
        <Text size="md" color="reduced">
          {t('adFleetMap_missionCard_andPassengersRequested_label', {
            totalPassengersToPickUp,
          })}
        </Text>
      </div>
      <VehicleTripsLink vehicleId={vehicle.id} />
    </div>
  )
}
